module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.basicinfo) ? _c('div', {
    staticStyle: {
      "width": "95%",
      "margin": "auto",
      "padding-bottom": "20px"
    }
  }, [_c('p', {
    staticClass: "boldTitle"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入活动名称（5-30个字）",
      "maxlength": "30",
      "minlength": "5",
      "disabled": _vm.isEdit == 2
    },
    model: {
      value: (_vm.hdmc),
      callback: function($$v) {
        _vm.hdmc = $$v
      },
      expression: "hdmc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动日期："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%",
      "cursor": "pointer",
      "background": "#fff",
      "border": "1px solid #eee"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptionsStart,
      "disabled": _vm.isEdit == 2
    },
    on: {
      "change": _vm.changeActiveTime
    },
    model: {
      value: (_vm.hdTime),
      callback: function($$v) {
        _vm.hdTime = $$v
      },
      expression: "hdTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "uploadActiveForm",
    attrs: {
      "label": "活动主图：",
      "prop": "bannerImgUrl"
    }
  }, [_c('div', {
    staticClass: "uploadActive"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "show-file-list": false,
      "disabled": _vm.isEdit == 2,
      "before-upload": function (file) { return _vm.beforeAvatarUpload(file, 1); }
    }
  }, [(_vm.bannerImgUrl) ? _c('div', {
    staticClass: "bannerImgUrl"
  }, [_c('el-image', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.bannerImgUrl,
      "fit": "cover"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.bannerImgUrl) ? _c('div', {
    staticClass: "bannerImgUrl"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("尺寸要求：1200*675，支持的图片格式：jpg、png；不超过5MB")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "uploadActiveForm",
    attrs: {
      "label": "分享封面：",
      "prop": "fxfmImgUrl"
    }
  }, [_c('div', {
    staticClass: "uploadActive"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "show-file-list": false,
      "disabled": _vm.isEdit == 2,
      "before-upload": function (file) { return _vm.beforeAvatarUpload(file, 2); }
    }
  }, [(_vm.fxfmImgUrl) ? _c('div', {
    staticClass: "fxfmImgUrl"
  }, [_c('el-image', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.fxfmImgUrl,
      "fit": "cover"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.fxfmImgUrl) ? _c('div', {
    staticClass: "fxfmImgUrl"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("尺寸要求：1000*800，支持的图片格式：jpg、png；不超过5MB")])])], 1), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": ""
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "boldTitle"
  }, [_vm._v("活动配置")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "margin": "auto",
      "border": "1px solid #eee"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "activityFormClass",
    attrs: {
      "span": 3
    }
  }, [_c('ul', {
    staticClass: "ulhdpz"
  }, _vm._l((_vm.leftActivityFormList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: index == _vm.isactive
      },
      attrs: {
        "value": item.id,
        "label": item.name
      },
      on: {
        "click": function($event) {
          return _vm.handleCurrentChange(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('b', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.zidingyiB))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit != 2),
      expression: "isEdit != 2"
    }],
    staticClass: "divBtn"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activityId != 10),
      expression: "activityId != 10"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.configuretitle()
      }
    }
  }, [_vm._v("配置标题")]), _vm._v(" "), (_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3 || _vm.activityId == 4 || _vm.activityId == 8 || _vm.activityId == 9 || _vm.activityId == 10) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addRelatedBrand()
      }
    }
  }, [_vm._v(" 新增 ")]) : _vm._e(), _vm._v(" "), ((_vm.activityId == 5 || _vm.activityId == 6 || _vm.activityId == 7) && (_vm.dataList.length != 1 || _vm.dataList == null)) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addRelatedBrand()
      }
    }
  }, [_vm._v(" 新增 ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "table_inner_container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    key: "1",
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), (_vm.activityId != 4) ? [(_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.brandName
          }
        }, [_vm._v(_vm._s(scope.row.brandName))])]
      }
    }], null, false, 3044227332)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "商品编码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.goodModelCode))])]
      }
    }], null, false, 3063615215)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.title))])]
      }
    }], null, false, 1442381006)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "市场价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.marketPrice))])]
      }
    }], null, false, 4065500327)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 5 || _vm.activityId == 6 || _vm.activityId == 7) ? _c('el-table-column', {
    attrs: {
      "label": "礼品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 2318523081)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 5 || _vm.activityId == 6 || _vm.activityId == 7) ? _c('el-table-column', {
    attrs: {
      "label": "礼品数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.number))])]
      }
    }], null, false, 1264468141)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 5) ? _c('el-table-column', {
    attrs: {
      "label": "核销时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.datetime))])]
      }
    }], null, false, 2571745871)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 8) ? _c('div', [_c('el-table-column', {
    attrs: {
      "label": "店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.shopname))]
      }
    }], null, false, 2506930046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品编码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodscode))]
      }
    }], null, false, 2420543744)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodsname))]
      }
    }], null, false, 3981461706)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodstypename))]
      }
    }], null, false, 2347083602)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.isonsalename))]
      }
    }], null, false, 116187098)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activityId == 9) ? _c('el-table-column', {
    attrs: {
      "label": "活动号码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.smackercode))]
      }
    }], null, false, 3650483280)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 10) ? _c('el-table-column', {
    key: "1",
    attrs: {
      "label": "小标题名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.remark))]
      }
    }], null, false, 3468652191)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 10) ? _c('el-table-column', {
    attrs: {
      "label": "图片内容",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#0099FF"
          },
          on: {
            "click": function($event) {
              return _vm.seebigimg(scope.row)
            }
          }
        }, [_vm._v("预览")])]
      }
    }], null, false, 3705891051)
  }) : _vm._e()] : [_c('el-table-column', {
    attrs: {
      "label": "优惠券名称",
      "prop": "name",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 2318523081)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面值",
      "prop": "facevalue",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.facevalue))])]
      }
    }], null, false, 2137774500)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "使用条件",
      "prop": "usethreshold",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.usethreshold))])]
      }
    }], null, false, 3430465978)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "售价",
      "prop": "price",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.price))])]
      }
    }], null, false, 1386323907)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "适用店铺",
      "prop": "shopname",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.shopname))])]
      }
    }], null, false, 2434242509)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优惠券数量",
      "prop": "number",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.number))])]
      }
    }], null, false, 1264468141)
  })], _vm._v(" "), (_vm.activityId == 1) ? _c('el-table-column', {
    attrs: {
      "label": "促销价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.promotionPrice))])]
      }
    }], null, false, 2177772080)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 2) ? _c('el-table-column', {
    attrs: {
      "label": "秒杀价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.seckillPrice))])]
      }
    }], null, false, 253295924)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 2) ? _c('el-table-column', {
    attrs: {
      "label": "数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.seckillStock))])]
      }
    }], null, false, 2775004889)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "团购价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.groupPrice))])]
      }
    }], null, false, 4118407772)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "成团人数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.groupNumber))])]
      }
    }], null, false, 1707783666)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "佣金",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.commissionRate))])]
      }
    }], null, false, 1771408097)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "235",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isEdit != 2 && _vm.activityId != 8 && _vm.activityId != 9) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handleActivity(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 修改\r\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit != 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteBrand(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\r\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.activityId == 9) ? _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.$index > 0),
            expression: "scope.$index > 0"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.spUpordown(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v(" 向上\r\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.activityId == 9) ? _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.$index < _vm.dataList.length - 1),
            expression: "scope.$index < dataList.length - 1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.spUpordown(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v(" 向下\r\n                  ")]) : _c('span', [(_vm.isEdit == 2) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeinfo(scope.row, 3)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看 ")]) : _vm._e()])]
      }
    }], null, false, 1236176236)
  })], 2)], 1)])])], 1), _vm._v(" "), _c('p', {
    staticClass: "boldTitle"
  }, [_vm._v("活动详情")]), _vm._v(" "), _c('wjEditor', {
    attrs: {
      "desc": _vm.ueditorValue
    },
    on: {
      "change": _vm.contentChangeOne
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "boldTitle"
  }, [_vm._v("引客到店奖现金：\r\n      "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit != 2),
      expression: "isEdit != 2"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.configuration(3)
      }
    }
  }, [_vm._v("配置")]), _vm._v(" "), (_vm.seejlfsOne != '') ? [_c('span', {
    staticClass: "threePrice"
  }, [_vm._v("单份奖励：" + _vm._s(_vm.rewardOne) + "元")]), _vm._v(" "), _c('span', {
    staticClass: "threePrice"
  }, [_vm._v("奖励份数：" + _vm._s(_vm.seejlfsOne) + "份")]), _vm._v(" "), _c('span', {
    staticClass: "threePrice"
  }, [_vm._v("需充值金额：" + _vm._s(Math.ceil(_vm.rechargeAmountOne * 100) / 100) + " 元")])] : [_c('span', {
    staticClass: "threePrice"
  }, [_vm._v("无配置")])], _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit != 2 && _vm.seejlfsOne != ''),
      expression: "isEdit != 2 && seejlfsOne != ''"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.chongzhiPz(1)
      }
    }
  }, [_vm._v("重置")])], 2), _vm._v(" "), _c('p', {
    staticClass: "boldTitle"
  }, [_vm._v("创客分享奖现金：\r\n      "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit != 2),
      expression: "isEdit != 2"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.configuration(2)
      }
    }
  }, [_vm._v("配置")]), _vm._v(" "), (_vm.seejlfsTwo != '') ? [_c('span', {
    staticClass: "threePrice"
  }, [_vm._v("单份奖励：" + _vm._s(_vm.rewardTwo) + "元")]), _vm._v(" "), _c('span', {
    staticClass: "threePrice"
  }, [_vm._v("奖励份数：" + _vm._s(_vm.seejlfsTwo) + "份")]), _vm._v(" "), _c('span', {
    staticClass: "threePrice"
  }, [_vm._v("需充值金额：" + _vm._s(Math.ceil(_vm.recharge.totalprice * 100) / 100) + " 元")])] : [_c('span', {
    staticClass: "threePrice"
  }, [_vm._v("无配置")])], _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit != 2 && _vm.seejlfsTwo != ''),
      expression: "isEdit != 2 && seejlfsTwo !=''"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.chongzhiPz(2)
      }
    }
  }, [_vm._v("重置")])], 2), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit == 2 ? '返回' : '取消'))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit != 2),
      expression: "isEdit != 2"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addedit(0)
      }
    }
  }, [_vm._v("确定")])], 1)], 1) : _c('addActiviteForm', {
    ref: "addActiviteForm",
    attrs: {
      "activityTypeFrom": _vm.activityTypeFrom
    },
    on: {
      "cancelActiveForm": _vm.cancelActiveForm,
      "newAdd": _vm.newlyAdded
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "自定义标题",
      "visible": _vm.zidingyiTitle,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.zidingyiTitle = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "自定义标题（10个字以内）",
      "maxlength": "11"
    },
    model: {
      value: (_vm.activitiesName),
      callback: function($$v) {
        _vm.activitiesName = $$v
      },
      expression: "activitiesName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.zidingyiTitle = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.complete()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "共创推广优惠券佣金上限",
      "visible": _vm.isToExamine,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入共创推广优惠券佣金上限",
      "maxlength": "20"
    },
    model: {
      value: (_vm.upperLimit),
      callback: function($$v) {
        _vm.upperLimit = $$v
      },
      expression: "upperLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("保存")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "幸运购",
      "visible": _vm.yiyuan,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.yiyuan = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入幸运购活动号码    例：230307001",
      "maxlength": "11"
    },
    model: {
      value: (_vm.yyqHdhm),
      callback: function($$v) {
        _vm.yyqHdhm = $$v
      },
      expression: "yyqHdhm"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.yiyuan = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.yyqSubmit()
      }
    }
  }, [_vm._v("保存")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "小标题",
      "visible": _vm.seeTksh,
      "center": true,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.seeTksh = $event
      }
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入小标题（10个字以内）",
      "maxlength": "10"
    },
    model: {
      value: (_vm.shenmark),
      callback: function($$v) {
        _vm.shenmark = $$v
      },
      expression: "shenmark"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "10px 0"
    }
  }, [_vm._l((_vm.images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "multigraph",
      attrs: {
        "data-img": img
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": img,
        "fit": "cover"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deldetail(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      }
    })])], 1)
  }), _vm._v(" "), (_vm.images.length < 10) ? _c('el-upload', {
    attrs: {
      "action": "",
      "multiple": "",
      "accept": ".png, .jpg,.jpeg",
      "limit": 10,
      "before-upload": function (file) { return _vm.multiGraphUpload(file); }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus upBtn"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "font-size": "13px"
    }
  }, [_vm._v("建议宽为1200像素，高不限，支持的图片格式：jpg、png。最大不超过5MB，最多支持上传10张。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.seeTksh = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.qdTksh()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.jxjTitle,
      "visible": _vm.prizeCash,
      "center": true,
      "width": "50%",
      "top": "50px"
    },
    on: {
      "update:visible": function($event) {
        _vm.prizeCash = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "单份奖励："
    }
  }, [(_vm.peizhiType == 3) ? _c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入",
      "onkeyup": "this.value=this.value.replace(/\\D|^0/g,'')"
    },
    model: {
      value: (_vm.rewardOne),
      callback: function($$v) {
        _vm.rewardOne = $$v
      },
      expression: "rewardOne"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])]) : _c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入",
      "onkeyup": "this.value=this.value.replace(/\\D|^0/g,'')"
    },
    model: {
      value: (_vm.rewardTwo),
      callback: function($$v) {
        _vm.rewardTwo = $$v
      },
      expression: "rewardTwo"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "奖励份数："
    }
  }, [(_vm.peizhiType == 3) ? _c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入奖励份数",
      "maxlength": "7"
    },
    model: {
      value: (_vm.shareOne),
      callback: function($$v) {
        _vm.shareOne = $$v
      },
      expression: "shareOne"
    }
  }) : _c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入奖励份数",
      "maxlength": "7"
    },
    model: {
      value: (_vm.recharge.totalcount),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "totalcount", $$v)
      },
      expression: "recharge.totalcount"
    }
  })], 1), _vm._v(" "), [(_vm.peizhiType == 3) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "充值金额："
    }
  }, [_c('span', [_c('b', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v(_vm._s(Math.ceil(_vm.rechargeAmountOne * 100) / 100))]), _vm._v(" 元")])]) : _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "充值金额："
    }
  }, [_c('span', [_c('b', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v(_vm._s(Math.ceil(_vm.recharge.totalprice * 100) / 100))]), _vm._v(" 元")])])]], 2), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.peizhiType == 3),
      expression: "peizhiType==3"
    }],
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("重要提示："), _c('span', [_vm._v("　本功能需要配置签到礼品")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.peizhiType == 2),
      expression: "peizhiType==2"
    }]
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "label": "分享规则："
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.fxdpyq),
      callback: function($$v) {
        _vm.fxdpyq = $$v
      },
      expression: "fxdpyq"
    }
  }, _vm._l((_vm.tasktyps), function(item) {
    return _c('el-radio', {
      key: item.bttid,
      staticStyle: {
        "margin-right": "15px"
      },
      attrs: {
        "label": item.bttid
      }
    }, [_vm._v(_vm._s(item.tasktypename))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "0"
    },
    attrs: {
      "label": "分享文案："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入分享文案内容",
      "maxlength": "100",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.recharge.remark),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "remark", $$v)
      },
      expression: "recharge.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "label": "分享要求："
    }
  }, [(_vm.tasktyps.length > 0) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, _vm._l((_vm.tasktyps.find(function (t) { return t.bttid == _vm.fxdpyq; }).descriptions), function(desc, index) {
    return _c('ul', {
      key: index
    }, [(desc.taskdesc.startsWith('【朋友圈】') || desc.taskdesc.startsWith('【微信群】')) ? _c('li', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\r\n                " + _vm._s(desc.taskdesc) + "\r\n              ")]) : _c('li', {
      staticStyle: {
        "color": "#999",
        "line-height": "30px"
      }
    }, [_vm._v("\r\n                " + _vm._s(desc.taskdesc) + "\r\n              ")])])
  }), 0) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("创客范围："), _c('span', [_vm._v("【本功用于配置哪些创客来进行推广】")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("按从事行业：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "800px"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "change": _vm.handleCheckedCities
    },
    model: {
      value: (_vm.formmenuOne),
      callback: function($$v) {
        _vm.formmenuOne = $$v
      },
      expression: "formmenuOne"
    }
  }, _vm._l((_vm.industry), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formmenuOne.find(function (i) { return i == 2; })),
      expression: "formmenuOne.find(i=>i==2)"
    }],
    staticStyle: {
      "height": "200px",
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("按建材品类：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "display": "grid",
      "padding": "0 10px 0 0"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminateTwo
    },
    on: {
      "change": function($event) {
        return _vm.handleCheckAllChange(_vm.checkAlltwo, 2)
      }
    },
    model: {
      value: (_vm.checkAlltwo),
      callback: function($$v) {
        _vm.checkAlltwo = $$v
      },
      expression: "checkAlltwo"
    }
  }, [_vm._v("\r\n            全部\r\n          ")]), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    staticClass: "cktree",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "show-checkbox": "",
      "data": _vm.category,
      "node-key": "id",
      "highlight-current": "",
      "props": _vm.defaultProps,
      "default-checked-keys": _vm.formmenuTwo
    }
  })], 1)])], 1), _vm._v(" "), _c('b', {
    staticStyle: {
      "display": "block",
      "margin": "10px 0"
    }
  }, [_vm._v("付费推广目的：")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.peizhiType == 3),
      expression: "peizhiType==3"
    }]
  }, _vm._l((_vm.ykddjxj), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "line-height": "32px"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.peizhiType == 2),
      expression: "peizhiType==2"
    }]
  }, [_vm._l((_vm.ckfxjxj), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "line-height": "32px"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("4.示例截图")]), _vm._v(" "), (_vm.tasktyps.length > 0) ? _c('ul', {
    staticClass: "videoandpic"
  }, _vm._l((_vm.tasktyps.find(function (i) { return i.bttid == _vm.fxdpyq; }).examples), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.mediatype == 2),
        expression: "item.mediatype == 2"
      }],
      staticClass: "el-icon-video-play mengceng"
    }), _vm._v(" "), _c('el-image', {
      staticStyle: {
        "width": "100px",
        "height": "100px"
      },
      attrs: {
        "src": _vm.baseOssUrl + item.mediapath,
        "fit": "cover",
        "preview-src-list": [_vm.baseOssUrl + item.mediapath]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), 0) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.prizeCash = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handleJxj()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), (_vm.isShowImageDialog) ? _c('div', {
    staticClass: "fullscreenMask",
    on: {
      "click": _vm.clearImg
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-close",
    staticStyle: {
      "position": "absolute",
      "top": "50px",
      "right": "50px",
      "font-size": "30px",
      "cursor": "pointer"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "800px",
      "margin": "200px 0 0 30%"
    }
  }, [_c('el-carousel', {
    attrs: {
      "autoplay": false,
      "height": "500px"
    }
  }, _vm._l((_vm.ShowImageDialogImgarr), function(item, index) {
    return _c('el-carousel-item', {
      key: index,
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%",
        "max-height": "100%"
      },
      attrs: {
        "src": item
      }
    })])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片查看",
      "visible": _vm.largeImage
    },
    on: {
      "update:visible": function($event) {
        _vm.largeImage = $event
      }
    }
  }, [_c('div', {
    staticClass: "imgDialog"
  }, [_c('img', {
    attrs: {
      "src": _vm.showImageUrl
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.videoVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片剪裁",
      "visible": _vm.cropping,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cropping = $event
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "fixedBox": _vm.option.fixedBox,
      "outputType": _vm.option.outputType,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "infoTrue": _vm.option.infoTrue,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "info": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "centerBox": _vm.option.centerBox,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cropping = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("确认")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "boldTitle"
  }, [_vm._v("付费推广\r\n      "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（活动结束后未使用的推广费用，5个工作日内将自动退款到原微信支付账户。）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13407080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/activityFormList.vue
// module id = 1640
// module chunks = 3